// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dynamic-content-preview-card{height:47.5rem;max-height:47.5rem;overflow-y:auto;font-size:2rem}.dynamic-content-preview-card .dynamic-content-preview{width:95%;height:95%}.el-dialog{width:49.375rem}", ""]);
// Exports
module.exports = exports;
